export default "__VITE_ASSET__CKFq_0uf__"